var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import EarlyAlertReasonService from "../../services/EarlyAlertReasonService";
import EarlyAlertReason from "../../models/EarlyAlertReason";
import Busy from "../shared/busy";
import Errors from "../shared/errors";
import EarlyAlertReasonsList from "./earlyAlertReasonsList";
import EarlyAlertReasonEdit from "./earlyAlertReasonEdit";
export default class EarlyAlertReasonList extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            editingReasonId: 0,
            errors: [],
            isEditingReason: false,
            isLoading: true,
            isSorting: false,
            reasons: [],
            sortProperties: {
                sort: "name",
                order: "asc",
            },
        };
        this.componentDidMount = () => {
            this.fetchReasons().then(() => {
                this.setState({ isLoading: false });
            });
        };
        this.fetchReasons = () => __awaiter(this, void 0, void 0, function* () {
            try {
                // prettier-ignore
                const response = yield EarlyAlertReasonService.fetchReasons(this.state.sortProperties.sort, this.state.sortProperties.order);
                this.setState({ reasons: response.data });
            }
            catch (e) {
                this.setState({ errors: [...this.state.errors, e] });
            }
        });
        this.onEditReasonClick = (reason) => {
            this.setState({
                editingReasonId: reason.id,
                isEditingReason: true,
            });
        };
        this.onNewReasonClick = () => {
            const newReason = new EarlyAlertReason();
            newReason.id = 0;
            this.onEditReasonClick(newReason);
        };
        this.onEarlyAlertReasonEditClose = () => {
            this.setState({
                isEditingReason: false,
            });
        };
        this.onAfterEditReasonSave = () => {
            this.setState({ isEditingReason: false });
            this.fetchReasons();
        };
        this.onSort = (name) => __awaiter(this, void 0, void 0, function* () {
            const newState = Object.assign({}, this.state.sortProperties);
            if (name === this.state.sortProperties.sort) {
                // @ts-expect-error - TS2540 - Cannot assign to 'order' because it is a read-only property.
                newState.order =
                    this.state.sortProperties.order === "asc" ? "desc" : "asc";
            }
            else {
                // @ts-expect-error - TS2540 - Cannot assign to 'sort' because it is a read-only property.
                newState.sort = name;
                // @ts-expect-error - TS2540 - Cannot assign to 'order' because it is a read-only property.
                newState.order = "asc";
            }
            this.setState({
                sortProperties: newState,
                isSorting: true,
            }, () => __awaiter(this, void 0, void 0, function* () {
                yield this.fetchReasons();
                this.setState({ isSorting: false });
            }));
        });
    }
    render() {
        return (_jsxs("div", { children: [_jsx(Busy, { isBusy: this.state.isLoading }), this.props.allowEdit && (_jsxs("div", { children: [_jsx("div", { children: _jsxs("button", { className: "btn btn-primary-outline mt-2", onClick: this.onNewReasonClick, type: "button", children: [_jsx("span", { className: "fa fa-plus", "aria-hidden": "true" }), " New"] }) }), _jsx(EarlyAlertReasonEdit, { reasonId: this.state.editingReasonId, isOpen: this.state.isEditingReason, onAfterSave: this.onAfterEditReasonSave, onModalClose: this.onEarlyAlertReasonEditClose })] })), _jsx(EarlyAlertReasonsList, { allowEdit: this.props.allowEdit, isSorting: this.state.isSorting, onEditReasonClick: this.onEditReasonClick, onSortClick: this.onSort, order: this.state.sortProperties.order, reasons: this.state.reasons, sort: this.state.sortProperties.sort }), _jsx(Errors, { errors: this.state.errors })] }));
    }
}
